<div class="ttm-holder">
    <div class="toolbar">
        <div>
            <button mat-stroked-button (click)="closeDialog()">
                <mat-icon>arrow_back</mat-icon>
                <span class="d-none d-sm-inline">Terug naar lijst</span>
            </button>
        </div>
        <div>
            @if (Features.TtmImagesUploadSave | hasFeature) {
                <button *ngIf="Settings.isMobileDevice" mat-stroked-button class="me-2" (click)="openCamera(imageCamera)" [disabled]="savingStatus">
                <span class="d-none d-sm-inline">
                    Camera
                </span>
                    <mat-icon iconPositionEnd>photo_camera</mat-icon>
                </button>
                <button mat-stroked-button class="me-2" (click)="openGallery(imageGallery)" [disabled]="savingStatus">
                <span class="d-none d-sm-inline">
                    Galerij
                </span>
                    <mat-icon iconPositionEnd class="fa-solid fa-images"></mat-icon>
                </button>
            }
            <button mat-stroked-button [matMenuTriggerFor]="menu" color="accent" class="flex-grow-0" [disabled]="savingStatus">
                Opties
                <mat-icon iconPositionEnd>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                @if (Features.TtmsHistoryDetail | hasFeature) {
                    <button mat-menu-item (click)="history.emit(ttm)">
                        <mat-icon>history</mat-icon>
                        <span>Geschiedenis</span>
                    </button>
                }
                <button mat-menu-item (click)="ticket.emit(ttm)" *ngIf="Features.TtmTicketsSave | hasFeature">
                    <mat-icon>live_help</mat-icon>
                    <span>Melden</span>
                </button>
                <button mat-menu-item (click)="details.emit(ttm)" *ngIf="Roles.Codalt | hasRole">
                    <mat-icon>info</mat-icon>
                    <span>Details</span>
                </button>
                <a mat-menu-item
                   href="https://maps.google.com/?q={{ttm.entities[0]?.gnd.coordinates[0][1]}},{{ttm.entities[0]?.gnd.coordinates[0][0]}}"
                   target="_blank">
                    <mat-icon>explore</mat-icon>
                    <span>Navigeer</span>
                </a>

                <button mat-menu-item (click)="copyTtmLink(ttm)">
                    <mat-icon>link</mat-icon>
                    <span>Delen</span>
                </button>

                <button mat-menu-item (click)="delete.emit(ttm)" *ngIf="Features.TtmsDetailDelete | hasFeature">
                    <mat-icon color="warn">delete</mat-icon>
                    <span>Verwijderen</span>
                </button>
            </mat-menu>
        </div>

    </div>
    <div class="details">
        <div class="ttm-image">
            <div app-svg-as-img [ttm]="ttm" (click)="openTtmSvg(ttm)">

            </div>
        </div>
        <div class="info">
            <div class="item">
                <app-status-chip class="me-3" [statusKey]="ttm?.status_key" [ttmStatuses]="ttmStatuses"></app-status-chip>

                <div class="id">
                    #{{ ttm.id }}
                </div>
            </div>
            <div class="properties">
                <div *ngIf="ttm.type.count" (click)="changeAmount()" class="property-change cursor-pointer" matRipple>
                    Aantal: <b>{{ ttm.amount ?? 1 }}</b>
                </div>
                <span class="pipe">|</span>
                <div>
                    Soort: <b>{{ (ttmTypes | byKey : ttm.type_key)?.name }}</b>
                </div>
                @for (field of weightingFields; track field) {
                    @if (ttm.type && ttm.type[field + '_name']) {
                        @if (Features.TtmsUpdateWeightingSave | hasFeature) {
                            <span class="pipe">|</span>
                            <div [matMenuTriggerFor]="weightingMenu" class="property-change">
                                {{ ttm.type[field + '_name'] }}:
                                @if (savingWeighting === field) {
                                    <i class="fa fa-spinner fa-spin"></i>
                                } @else {
                                    <b>{{ ttm[field] ? 'Ja' : 'Nee' }}</b>
                                }
                            </div>

                            <mat-menu #weightingMenu="matMenu">
                                <button [disabled]="savingWeighting" mat-menu-item (click)="updateTtmWeightingField(true, field)">Ja</button>
                                <button [disabled]="savingWeighting" mat-menu-item (click)="updateTtmWeightingField(false, field)">Nee</button>
                            </mat-menu>
                        } @else {
                            <span class="pipe">|</span>
                            <div>
                                {{ ttm.type[field + '_name'] }}:
                                <b>{{ ttm[field] ? 'Ja' : 'Nee' }}</b>
                            </div>
                        }
                    }
                }
            </div>
        </div>
    </div>
    @if (ttm.type_key === TtmTypes.deviations) {
        <div class="mb-2">
            {{ ttm.entities[0].attr?.text }}
        </div>
    }
    <div class="images">
        <div class="image-list">
            <div class="image-list-wrap">
                @for (image of images; track image.id; let i = $index) {
                    <div class="image-wrap" (press)="showImageDelete($event, image)" (contextmenu)="showImageDelete($event, image)"
                         [class.remove-active]="showDelete === image">
                        <div class="image" (click)="openImage(image)">
                            <div *ngIf="showDelete === image" class="remove-action" (click)="deleteImage($event, image)" matRipple>
                                <i class="fa-regular fa-trash"></i>
                            </div>
                            <app-codalt-image *ngIf="image.id" url="ttm-images/image/{{image.id}}"></app-codalt-image>
                            <mat-spinner *ngIf="!image.id"></mat-spinner>
                        </div>
                        @if (image.id) {
                            <div class="image-info">
                                <app-status-chip class="me-3" [statusKey]="image?.ttm_status_key" [ttmStatuses]="ttmStatuses"></app-status-chip>

                                <div>
                                    {{ image.created_at | date : 'd MMM yyyy H:mm' }}
                                </div>
                            </div>
                            <div class="image-info">
                                <div class="username">
                                    @if (Features.ShowSensetiveInformation | hasFeature) {
                                        <i class="fa-solid fa-user-large me-1"></i> {{ image.user?.name }}
                                    }
                                </div>
                                <div>
                                    @if (ttmImageDistance.get(image.id)) {
                                        <mat-chip class="distance-chip" (click)="onOpenLocation(i)" matTooltip="Afstand foto tot locatie tekening">
                                            <i class="fa-solid fa-location-dot"></i> {{ ttmImageDistance.get(image.id) }}
                                        </mat-chip>
                                    }
                                </div>
                            </div>
                        } @else {
                            <div>
                                Bezig met uploaden...
                            </div>
                        }
                    </div>
                }
                <div class="hidden-flex-item"></div>
                <div class="hidden-flex-item"></div>
                <div class="hidden-flex-item"></div>
                <div class="hidden-flex-item"></div>
                <div class="hidden-flex-item"></div>
            </div>
        </div>
    </div>
    <div class="pt-3">
        <mat-form-field class="w-100 pb-3 comment" appearance="outline" color="primary">
            <mat-label>Opmerking</mat-label>
            <textarea [formControl]="fgComment.controls.comment" cdkTextareaAutosize matInput placeholder="Plaats hier een opmerking"></textarea>
            @if (Features.TtmsUpdateCommentSave | hasFeature) {
                <button mat-icon-button matSuffix (click)="saveComment()" [disabled]="fgComment.pristine || savingComment">
                    <mat-icon *ngIf="!savingComment" class="fa-solid fa-floppy-disk"></mat-icon>
                    <mat-icon *ngIf="savingComment" class="fas fa-circle-notch fa-spin"></mat-icon>
                </button>
            }
            @if (Features.TtmsUpdateCommentSave | hasFeature) {
                <mat-hint *ngIf="fgComment.controls.comment.value">
                    <mat-checkbox [formControl]="fgComment.controls.comment_show_on_status_change" [checked]="true" class="p-0" color="primary">
                        Tonen bij statuswijziging
                    </mat-checkbox>
                    <mat-checkbox [formControl]="fgComment.controls.comment_send_notification" class="p-0 ms-3" color="primary">Melding versturen</mat-checkbox>
                    <mat-checkbox [formControl]="fgComment.controls.comment_show_on_map" class="p-0 ms-3" color="primary">Tonen op kaart</mat-checkbox>
                </mat-hint>
            }

        </mat-form-field>
    </div>
    <div class="actions">
        @if (ttm.type_key !== TtmTypes.deviations && (Features.TtmsUpdateStatusSave | hasFeature)) {
            <div class="status">
                <button mat-stroked-button color="primary" (click)="updateStatus()" [disabled]="savingStatus">
                    @if (savingStatus) {
                        <mat-icon class="fas fa-circle-notch fa-spin"></mat-icon>
                    } @else {
                        <mat-icon>edit</mat-icon>
                    }
                    Status wijzigen
                </button>
            </div>
        }
    </div>
</div>

<input (change)="uploadFile($event)" type="file" id="imageCamera" name="imageCamera" accept="image/*" capture="environment" hidden #imageCamera/>
<input (change)="uploadFile($event)" type="file" id="imageGallery" name="imageGallery" accept="image/*" hidden #imageGallery/>

